import {Button, DialogActions, DialogContent, DialogTitle, TextField, useMediaQuery, useTheme} from "@mui/material";
import {IntegrationDialog as Dialog, IntegrationProviderGrid} from "../IntegrationDesign";
import {SettingsDialogDescription} from "../../SettingsDialog";
import React, {useState, useCallback} from "react";

function ChooseServerIntegration(props) {

    const theme = useTheme();
    const [searchQuery, setSearchQuery] = useState("");

    const templates = [
        {
            name: "AWS",
            logoUrl: "/assets/images/servers/aws.svg"
        },
        {
            name: "Cloudflare",
            logoUrl: "/assets/images/servers/cloudflare.svg"
        },
        {
            name: "Namesilo",
            logoUrl: "/assets/images/servers/namesilo.svg"
        }
    ];

    const integrations = ["AWS", "Cloudflare", "Namesilo"];

    const [open, setOpen] = useState(true);

    const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

    const handleChange = event => {
        setSearchQuery(event.target.value);
    };

    const selectIntegration = (item) => {
        if (item?.name === "AWS") {
            props.history.push({pathname: "/settings/integrations/server-aws", state: {from: props.location}});
        }
        if (item?.name === "Cloudflare") {
            props.history.push({pathname: "/settings/integrations/server-cloudflare", state: {from: props.location}});
        }
        if (item?.name === "Namesilo") {
            props.history.push({pathname: "/settings/integrations/server-namesilo", state: {from: props.location}});
        }
    };

    const handleClose = useCallback((event, reason) => {
        if (reason === 'backdropClick') {
            return false;
        }
        setOpen(false);
        props.history.push({pathname: "/settings/integrations", state: {from: props.location}});
    }, [props]);

    const filteredTemps = !searchQuery
        ? templates
        : templates?.filter(item =>
            item?.name?.toLowerCase().includes(searchQuery.toLocaleLowerCase())
        );

    return (
        <Dialog open={open} onClose={handleClose} fullWidth fullScreen={fullScreen} maxWidth="sm" aria-labelledby="choose-server-or-domain-integration">
            <DialogTitle id="choose-server-or-domain-integration">Choose server or domain provider
                <SettingsDialogDescription>Connect your hosting or domain provider to manage websites and SSL certificates.</SettingsDialogDescription>
            </DialogTitle>
            <DialogContent sx={{minHeight: 280, position: 'relative'}}>
                <TextField variant="outlined" size="small" margin="dense" label="Search providers" name="server"
                    placeholder="Search by provider name" fullWidth slotProps={{inputLabel: {shrink: true}}}
                    value={searchQuery} onChange={handleChange}/>
                <IntegrationProviderGrid templates={filteredTemps?.filter(item => integrations.includes(item?.name))} onSelect={selectIntegration}/>
            </DialogContent>
            <DialogActions><Button onClick={handleClose} color="inherit">Cancel</Button></DialogActions>
        </Dialog>
    );
}

export default ChooseServerIntegration;
